import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useCallback } from 'react';
/** 12px chevron SVG pointing right. Rotated 90deg when expanded. */
const ChevronSvg = React.memo(function ChevronSvg({ expanded }) {
    return (_jsx("svg", { "aria-hidden": "true", width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", style: {
            transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
            transition: 'transform 150ms ease',
            flexShrink: 0,
        }, children: _jsx("path", { d: "M4.5 2.5L8 6L4.5 9.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) }));
});
export function SidebarGroup({ id, label, defaultExpanded = true, expanded: controlledExpanded, onToggle, children, }) {
    const [internalExpanded, setInternalExpanded] = useState(defaultExpanded);
    const isControlled = controlledExpanded !== undefined;
    const expanded = isControlled ? controlledExpanded : internalExpanded;
    const [hovered, setHovered] = useState(false);
    const handleToggle = useCallback(() => {
        const next = !expanded;
        if (onToggle)
            onToggle(next);
        if (!isControlled)
            setInternalExpanded(next);
    }, [expanded, onToggle, isControlled]);
    const itemsId = `${id}-items`;
    return (_jsxs("div", { "data-sidebar-group": true, style: { marginBottom: 16 }, children: [_jsxs("button", { type: "button", "aria-expanded": expanded, "aria-controls": itemsId, onClick: handleToggle, onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'var(--sp-1)',
                    width: '100%',
                    minHeight: 28,
                    padding: '0 var(--sp-3)',
                    margin: 0,
                    border: 'none',
                    background: hovered ? 'var(--surface-alt)' : 'transparent',
                    borderRadius: 'var(--radius-sm)',
                    cursor: 'pointer',
                    fontSize: 'var(--fs-sm)',
                    fontWeight: 600,
                    fontFamily: 'inherit',
                    color: 'var(--text-muted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.04em',
                    textAlign: 'left',
                }, children: [_jsx(ChevronSvg, { expanded: expanded }), _jsx("span", { children: label })] }), _jsx("ul", { id: itemsId, role: "list", style: {
                    display: expanded ? 'block' : 'none',
                    listStyle: 'none',
                    margin: 0,
                    padding: 0,
                }, children: children })] }));
}
//# sourceMappingURL=SidebarGroup.js.map